/*
 * File: auto-modal.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:45:01
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { MixinAuto } from "@root/components/base-classes";
import Modal from "../modal/modal";

@Component({
    mixins: [MixinAuto],
})
export default class AutoModal extends Modal {
    /// public methods
    show() {
        this.innateVisible = true;
    }
    hide() {
        this.innateVisible = false;
    }
    toggle() {
        this.innateVisible = !this.innateVisible;
    }
}
